import React, { useEffect, useMemo, useRef, useState } from 'react';
import cn from "classnames";
import style from "../common.module.scss"
import OrdersSectionItemTableStatus from "./OrdersSectionItemTableStatus";
import { numberToFinanceFormat } from "../../../../utils";
import Loading from "../../../shared/Loading/Loading";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import 'moment/locale/ru'
import EmptyContent from '../../../shared/emptyContent';
import DistanceIcon from '../../../shared/icons/DistanceIcon';
import KazahstanIcon from '../../../shared/icons/country/KazahstanIcon.png'
import RussianIcon from '../../../shared/icons/country/RussianIcon.png'
import UsbekistanIcon from '../../../shared/icons/country/UsbekistanIcon.png'
import ArrowDownIcon from '../../../shared/icons/ArrowDownIcon';
import OrderInfo from '../../order-info/OrderInfo';
import { useTranslation } from 'react-i18next';


moment.locale("ru")

const OrdersSectionItemTable = ({
  isLoading = false,
  items = [],
  isExpeditor = false,
  companyName,
  onForceUpdate
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("orderId");

  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const countryIcons = {
    "63556b49614a6ddc9ceeb61e": KazahstanIcon,
    "63556bc1614a6ddc9ceeb61f": RussianIcon,
    "648b0836d64a46fc66c74273": UsbekistanIcon,
  };

  const handleOpenOrderInfo = (orderId) => {
    setSelectedOrderId(null)
    setSelectedOrderId(orderId);
    setIsOpenInfo(true);
  };

  const handleClickOutside = (event) => {
    if (tableRef.current && !tableRef.current.contains(event.target)) {
      setIsOpenInfo(false);
    }
  };

  useEffect(() => {
    if (orderId) handleOpenOrderInfo(orderId);
  }, [orderId]);

  useEffect(() => {
    if (isOpenInfo) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpenInfo]);

  const tableHead = useMemo(() => {
    return [
      {
        name: t("common.tableHead.details"),
        isSortable: false,
        key: "number"
      },
      // {
      //   name: "Стоимость",
      //   isSortable: true,
      //   key: isExpeditor ? "netPrice" : "price",
      // },
      {
        name: t("common.tableHead.from"),
        isSortable: false,
        key: "addressFrom",
      },
      {
        component: <DistanceIcon />,
        isSortable: false,
        key: "addressTo",
      },
      {
        name: t("common.tableHead.to"),
        isSortable: false,
        key: "addressTo",
      },
      {
        name: t("common.tableHead.status"),
        isSortable: false,
      },
      {
        name: t("common.tableHead.transport"),
        isSortable: false,
      },
      {
        name: "",
        isSortable: false,
      }
    ]
  }, [isExpeditor, t])

  return (
    <div className={cn(style.table_wrapper, 'table-responsive')} ref={tableRef}>
      <table className="table">
        <thead>
          <tr>
            {tableHead.map((item, idx) => (
              <th scope="col" key={'head-' + idx}>
                <div className={style.tableHead}>
                  {item.component ? item.component : item.name}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={item.number + idx} onClick={() => handleOpenOrderInfo(item.id)} className="cursor-pointer">
              <td>
                <div className={style.table_col}>
                  <span>{numberToFinanceFormat(item.price)}〒</span>
                  <span className={style.table_col_summary}>№ {item.number}</span>
                </div>
              </td>
              <td>
                <div className={style.table_col}>
                  <div className={style.table_col_country}>
                    <img
                      src={countryIcons[item.countryIdFrom]}
                      className={style.table_col_countryIcon}
                    />
                    {item.cityFromName}
                  </div>
                  <span className={style.table_col_summary}>
                    {moment.utc(item.shippingDate)
                      .startOf('day')
                      .add(item.shippingHourFrom, 'hours')
                      .format("D MMMM, HH:mm")}
                  </span>
                </div>
              </td>
              <td>
                <div className={style.table_col_distance}>{numberToFinanceFormat(item.distance || '-')} {t ('analytics.distance_metric')}</div>
              </td>
              <td>
                <div className={style.table_col}>
                  <div className={style.table_col_country}>
                    <img
                      src={countryIcons[item.countryIdTo]}
                      className={style.table_col_countryIcon}
                    />
                    {item.cityToName}
                  </div>
                  <span className={style.table_col_summary}>
                    {moment.utc(item.unloadingDate)
                      .startOf('day')
                      .add(item.unloadingHourFrom, 'hours')
                      .format("D MMMM, HH:mm")}
                  </span>
                </div>
              </td>
              <td>
                <div>
                  <OrdersSectionItemTableStatus status={item.status} driverName={item.driverName} driverSurname={item.driverSurname} />
                </div>
              </td>
              <td>
                <div className={style.table_col}>
                  <div className={style.table_col_country}>
                    {item.vehicleTypeName}
                  </div>
                  <span className={style.table_col_summary}>
                    {item.carModel}
                  </span>
                </div>
              </td>
              <td>
                <div className={style.table_col_arrow}>
                  <ArrowDownIcon style={{ transform: "rotate(270deg)" }} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <OrderInfo
        isOpen={isOpenInfo}
        setIsOpen={setIsOpenInfo}
        orderId={selectedOrderId}
        companyName={companyName}
        onForceUpdate={onForceUpdate}
      />
      {isLoading
        ? <Loading inBlock />
        : !items.length
          ? <EmptyContent />
          : null
      }
    </div>
  );
};

export default OrdersSectionItemTable;